import React, { useState } from 'react';
import { ContactForm } from './ContactForm';
import '../Styles/Footer.css';

export function Footer() {
	const [isContactOpen, setIsContactOpen] = useState(false);
	const currentYear = new Date().getFullYear();

	return (
		<footer className="footer-container">
			<div className="footer-content">
				<div className="footer-left">
					<p>© {currentYear} Erik Watchorn</p>
					<span className="footer-stack">Built with React</span>
				</div>
				
				<div className="footer-right">
					<a href="/Files/ErikWatchornCV.pdf" target="_blank" className="footer-link">CV</a>
					<a href="https://github.com/erikwtn" target="_blank" rel="noreferrer" className="footer-link">GitHub</a>
					<a href="https://www.linkedin.com/in/erik-watchorn-053bb2276/" target="_blank" rel="noreferrer" className="footer-link">LinkedIn</a>
					<a href="https://erikwtn.itch.io" target="_blank" rel="noreferrer" className="footer-link">Itch.io</a>
					
					<button 
						onClick={() => setIsContactOpen(true)} 
						className="footer-link-btn"
					>
						Contact
					</button>
				</div>
			</div>

			<ContactForm 
				isOpen={isContactOpen} 
				onClose={() => setIsContactOpen(false)} 
			/>
		</footer>
	);
}